;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('GitHubService', GitHubService)

  function GitHubService(
    $location,
    $q,
    $cacheFactory,
    UserService,
    rulesBugtrackerService,
    ServiceUtils,
    BugtrackerFactory,
    GITHUB_BASIC_AUTH,
    FILTER_GROUPS
  ) {
    'ngInject'

    var cache = undefined
    var _undefinedRepo = '$undefined'
    var _cacheId = 'githubVals'

    return {
      getGitHubBugtracker: getGitHubBugtracker,
      refreshGitHubBugtracker: refreshGitHubBugtracker,
      testGitHubBugtracker: testGitHubBugtracker,
      getGitHubBugtrackerForVulnerability: getGitHubBugtrackerForVulnerability,
      getGitHubBugtrackerForLibrary: getGitHubBugtrackerForLibrary,
      refreshExistingGitHubBugtracker: refreshExistingGitHubBugtracker,
      testExistingGitHubBugtracker: testExistingGitHubBugtracker,
      addGitHubBugtracker: addGitHubBugtracker,
      editGitHubBugtracker: editGitHubBugtracker,

      buildGitHubBugtracker: buildGitHubBugtracker,
      buildGitHubIntegrationTest: buildGitHubIntegrationTest,
      buildGitHubIntegration: buildGitHubIntegration,
      addGitHubIntegration: addGitHubIntegration,
      transformToIntegrationView: transformToIntegrationView,
      updateRepositoryCache: updateRepositoryCache,
      clearCache: clearCache
    }

    function getGitHubBugtracker(id) {
      _destroyCache()
      return BugtrackerFactory.getGitHubBugtracker(id)
        .then(function (response) {
          _cacheGitHubValues(response.data.settings, true)
          return {
            bugtracker: response.data.bugtracker,
            settings: response.data.settings
          }
        })
        .catch(ServiceUtils.handleError)
    }

    function refreshGitHubBugtracker(data) {
      if (_areGitHubValuesCached(data)) {
        return _getCachedValuesAsPromise(data)
      }
      return BugtrackerFactory.refreshGitHubBugtracker(data).then(
        function (response) {
          _cacheGitHubValues(
            response.data.settings,
            angular.isDefined(data.repository)
          )
          return response.data.settings
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function testGitHubBugtracker(data) {
      _destroyCache()
      return BugtrackerFactory.testGitHubBugtracker(data)
        .then(
          function (response) {
            _cacheGitHubValues(response.data.settings, true)
            return response.data.settings
          },
          function (response) {
            return $q.reject(response.data)
          }
        )
        .catch(ServiceUtils.handleError)
    }

    function getGitHubBugtrackerForVulnerability(id, appId) {
      return BugtrackerFactory.getGitHubBugtrackerForVulnerability(
        id,
        appId
      ).then(
        function (response) {
          return {
            bugtracker: response.data.bugtracker,
            settings: response.data.settings
          }
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function getGitHubBugtrackerForLibrary(bugtrackerId) {
      return BugtrackerFactory.getGitHubBugtrackerForLibrary(bugtrackerId)
        .then(function (response) {
          return {
            bugtracker: response.data.bugtracker,
            settings: response.data.settings
          }
        })
        .catch(ServiceUtils.handleError)
    }

    function refreshExistingGitHubBugtracker(id, data) {
      if (_areGitHubValuesCached(data)) {
        return _getCachedValuesAsPromise(data)
      }
      return BugtrackerFactory.refreshExistingGitHubBugtracker(id, data).then(
        function (response) {
          _cacheGitHubValues(
            response.data.settings,
            angular.isDefined(data.repository)
          )
          return response.data.settings
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function testExistingGitHubBugtracker(id, data) {
      _destroyCache()
      return BugtrackerFactory.testExistingGitHubBugtracker(id, data).then(
        function (response) {
          _cacheGitHubValues(response.data.settings, true)
          return response.data.settings
        },
        function (response) {
          return $q.reject(response.data)
        }
      )
    }

    function addGitHubBugtracker(bugtracker) {
      return BugtrackerFactory.addGitHubBugtracker(bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          _destroyCache()
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function editGitHubBugtracker(id, bugtracker) {
      return BugtrackerFactory.editGitHubBugtracker(id, bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          _destroyCache()
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    // GitHub
    function buildGitHubBugtracker(model) {
      var bugtracker = {}
      bugtracker.name = model.name
      bugtracker.host = model.host
      bugtracker.auth_type = model.auth_type

      if (GITHUB_BASIC_AUTH == model.auth_type) {
        bugtracker.username = model.username
        bugtracker.password = model.password
      } else {
        bugtracker.token = model.password
      }

      bugtracker.applications = model.applications
      bugtracker.all_applications = model.all_applications
      bugtracker.assignee = model.assignee
      bugtracker.issue_type = model.issue_type
      bugtracker.project = model.project

      bugtracker.auto_create_tickets_enabled = model.auto_create_tickets_enabled
      bugtracker.auto_create_tickets_rules = model.auto_create_tickets_rules
      bugtracker.auto_create_tickets_severities =
        model.auto_create_tickets_severities
      bugtracker.auto_create_tickets_all_rules =
        model.auto_create_tickets_all_rules

      bugtracker.integrations = []

      bugtracker.github_organization = model.github_org
      bugtracker.repository = model.repository

      bugtracker.assignees = model.assignees
      bugtracker.labels = model.labels
      bugtracker.milestone = model.milestone

      return bugtracker
    }

    function buildGitHubIntegrationTest(model) {
      var request = {}

      request.name = model.name
      request.host = model.host
      if (angular.isDefined(model.github_organization)) {
        request.github_org = model.github_organization.login
      }
      if (angular.isDefined(model.repository)) {
        request.repository = model.repository.name
      }
      request.auth_type = model.auth_type.value
      request.username = model.username
      request.password = _extractPassword(model)

      return request
    }

    function buildGitHubIntegration(model) {
      var request = {}

      request.name = model.name
      request.host = model.host
      request.username = model.username
      request.auth_type = model.auth_type.value
      request.password = _extractPassword(model)

      request.all_applications = model.all_applications
      if (request.all_applications) {
        request.applications = []
      } else {
        request.applications = _.map(model.applications, 'app_id')
      }
      request.assignee = model.assignee
      request.issue_type = model.issue_type
      request.project = model.project

      request.auto_create_tickets_enabled = model.auto_create_tickets_enabled
      request.auto_create_tickets_rules = []
      request.auto_create_tickets_severities = []

      if (!model.auto_create_tickets_enabled) {
        request.auto_create_tickets_all_rules = false
      } else {
        if (model.auto_create_tickets_all_rules) {
          request.auto_create_tickets_all_rules = true
        } else {
          _buildRulesRequestSection(request, model)
          request.auto_create_tickets_all_rules = false
        }
      }

      request.github_org = model.github_organization.login
      request.repository = model.repository.name

      request.fields = {}

      if (model.assignees) {
        request.fields.assignees = _.map(model.assignees, 'login')
      }
      if (model.labels) {
        request.fields.labels = _.map(model.labels, 'name')
      }
      if (model.milestone) {
        request.fields.milestone = model.milestone.number
      }

      return request
    }

    function _extractPassword(model) {
      if (GITHUB_BASIC_AUTH === model.auth_type.value) {
        return model.password
      }
      return model.token
    }

    function addGitHubIntegration(data, properties) {
      data.github_fields = {}

      if (properties.assignees) {
        data.github_fields.assignees = _.map(properties.assignees, 'login')
      }
      if (properties.labels) {
        data.github_fields.labels = _.map(properties.labels, 'name')
      }
      if (properties.milestone) {
        data.github_fields.milestone = properties.milestone.number
      }
    }

    function transformToIntegrationView(integration, rules) {
      var form = {
        name: integration.name,
        host: integration.host,
        username: integration.username,
        password: integration.password,
        auth_type: integration.auth_type,
        applications: integration.applications,
        all_applications: integration.all_applications,
        assignee: integration.assignee,
        issue_type: integration.issue_type,
        project: integration.project,

        github_organization: integration.github_organization,
        repository: integration.repository,

        labels: integration.labels,
        assignees: integration.assignees,
        milestone: integration.milestone,

        auto_create_tickets_enabled: integration.auto_create_tickets_enabled,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: [],
        auto_create_tickets_all_rules:
          integration.auto_create_tickets_all_rules,

        integration: integration.integration,
        integrations: integration.integrations,
        placeholderURL: integration.placeholderURL
      }

      if (!form.auto_create_tickets_all_rules) {
        rulesBugtrackerService.transformRulesToIntegrationView(
          integration,
          rules,
          form
        )
      }

      return form
    }

    function _buildRulesRequestSection(data, integration) {
      var j, ruleItem
      for (j = 0; j < integration.auto_create_tickets_rules.length; j++) {
        ruleItem = integration.auto_create_tickets_rules[j]
        if (ruleItem.group === FILTER_GROUPS.SEVERITY) {
          data.auto_create_tickets_severities.push(ruleItem.value)
        } else {
          data.auto_create_tickets_rules.push(ruleItem.value)
        }
      }
    }

    function updateRepositoryCache(org, repo) {
      if (angular.isUndefined(cache)) {
        return
      }
      var data = {
        github_org: org,
        repository: undefined
      }
      var settings = _getCachedValues(data)
      data.repository = repo
      if (angular.isDefined(settings)) {
        if (!_areGitHubValuesCached(data)) {
          _cacheGitHubValues(settings, true)
        }
      } else {
        settings = _getCachedValues(data)
        _cacheGitHubValues(settings, false)
      }
    }

    function clearCache() {
      _destroyCache()
    }

    function _getCachedValuesAsPromise(data) {
      var deferred = $q.defer()
      deferred.resolve(_getCachedValues(data))
      return deferred.promise
    }

    function _areGitHubValuesCached(data) {
      _initCache()
      var id = _getCacheIdForGitHubRequest(data.github_org, data.repository)
      return angular.isDefined(cache.get(id))
    }

    function _getCachedValues(data) {
      _initCache()
      var id = _getCacheIdForGitHubRequest(data.github_org, data.repository)
      return cache.get(id)
    }

    function _cacheGitHubValues(settings, isRepoData) {
      _initCache()
      var org = settings.selected_organization.organization
      // If the values to be cached only contain repository data
      var repo = isRepoData
        ? settings.selected_organization.repository_settings.repository
        : undefined
      var id = _getCacheIdForGitHubRequest(org, repo)
      cache.put(id, settings)
    }

    function _getCacheIdForGitHubRequest(githubOrg, repository) {
      if (angular.isDefined(repository)) {
        return githubOrg + '-' + repository
      }
      return githubOrg + '-' + _undefinedRepo
    }

    function _initCache() {
      if (angular.isUndefined(cache)) {
        cache = $cacheFactory(_cacheId)
      }
    }

    function _destroyCache() {
      if (angular.isDefined(cache)) {
        cache.destroy()
        cache = undefined
      }
    }
  }
})()
